import React, { useState } from 'react';

const DonationOne = () => {
  const [activeTab, setActiveTab] = useState('monthly');
  const [selectedMonthly, setSelectedMonthly] = useState('₦5,000');
  const [selectedOneTime, setSelectedOneTime] = useState('₦5,000');

  const monthlyOptions = ['₦5,000', '₦10,000', '₦20,000', '₦50,000', '₦100,000'];
  const oneTimeOptions = ['₦5,000', '₦10,000', '₦20,000', '₦50,000', '₦100,000'];
  return (
    <section className="donation-one">
      <div className="donation-one__shape-1 float-bob-y">
        <img src="assets/images/shapes/donation-one-shape-1.png" alt="" />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6">
            <div className="donation-one__left">
              <div className="donation-one__img">
                <img src="assets/images/Boys.gif" alt="Rayyan Aid – beneficiaries" />
              </div>
              <div className="donation-one__video-box">
                <div className="donation-one__video-box-bg" style={{ backgroundImage: 'url(assets/images/12.avif)' }}></div>
                <div className="donation-one__video-link">
                  <a href="https://www.youtube.com/watch?v=Get7rqXYrbQ" className="video-popup">
                    <div className="donation-one__video-icon">
                      <span className="icon-play-button-arrowhead"></span>
                      <i className="ripple"></i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="donation-one__right-inner">
              <div className="section-title text-left sec-title-animation animation-style2">
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline">Donate to Rayyan Aid</span>
                </div>
                <h2 className="section-title__title title-animation">Your gift restores <span>dignity</span> and <span>opportunity</span></h2>
              </div>
              <div className="donation-one__right">
                <div className="donation-one__right-shape-1 float-bob-x">
                  <img src="assets/images/shapes/donation-one-right-shape-1.png" alt="" />
                </div>
                <h3 className="donation-one__right-title">Select gift frequency</h3>
                <div className="donation-one__main-tab-box tabs-box">
                  <ul className="tab-buttons list-unstyled">
                    <li
                      data-tab="#monthly"
                      className={`tab-btn tab-btn-one ${activeTab === 'monthly' ? 'active-btn' : ''}`}
                      onClick={() => setActiveTab('monthly')}
                    >
                      <span>Monthly</span>
                    </li>
                    <li
                      data-tab="#onetime"
                      className={`tab-btn tab-btn-two ${activeTab === 'onetime' ? 'active-btn' : ''}`}
                      onClick={() => setActiveTab('onetime')}
                    >
                      <span>one time</span>
                    </li>
                  </ul>
                  <div className="tabs-content">
                    <div className={`tab ${activeTab === 'monthly' ? 'active-tab' : ''}`} id="monthly">
                      <div className="donation-one__inner">
                        <h3 className="donation-one__amount-title">Select Amount <span>( in NGN )</span></h3>
                        <div className="donation-one__donate-box">
                          <button
                            className={`amount-btn-1 ${selectedMonthly === monthlyOptions[0] ? 'active' : ''}`}
                            onClick={() => setSelectedMonthly(monthlyOptions[0])}
                          >
                            <span>₦</span>5,000
                          </button>
                          <div className="donate-amount">
                            <input type="text" className="addAmount-value" placeholder="Custom Amount" />
                            {monthlyOptions.slice(1).map((amt) => (
                              <button
                                key={amt}
                                className={`amount-btn ${selectedMonthly === amt ? 'active' : ''}`}
                                onClick={() => setSelectedMonthly(amt)}
                              >
                                {amt}
                              </button>
                            ))}
                          </div>
                        </div>
                        <div className="checked-box">
                          <input type="checkbox" name="skipper1" id="skipper" defaultChecked />
                          <label htmlFor="skipper"><span></span>Make my donation go further with monthly support.</label>
                        </div>
                        <div className="donation-one__btn-box">
                          <a href="/about" className="thm-btn">
                            <span className="thm-btn-text">Donate Now</span>
                            <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className={`tab ${activeTab === 'onetime' ? 'active-tab' : ''}`} id="onetime">
                      <div className="donation-one__inner">
                        <h3 className="donation-one__amount-title">Select Amount <span>( in NGN )</span></h3>
                        <div className="donation-one__donate-box">
                          <button
                            className={`amount-btn-1 ${selectedOneTime === oneTimeOptions[0] ? 'active' : ''}`}
                            onClick={() => setSelectedOneTime(oneTimeOptions[0])}
                          >
                            <span>₦</span>5,000
                          </button>
                          <div className="donate-amount">
                            <input type="text" className="addAmount-value" placeholder="Custom Amount" />
                            {oneTimeOptions.slice(1).map((amt) => (
                              <button
                                key={amt}
                                className={`amount-btn ${selectedOneTime === amt ? 'active' : ''}`}
                                onClick={() => setSelectedOneTime(amt)}
                              >
                                {amt}
                              </button>
                            ))}
                          </div>
                        </div>
                        <div className="checked-box">
                          <input type="checkbox" name="skipper2" id="skipper2" defaultChecked />
                          <label htmlFor="skipper2"><span></span>Send updates on how my gift makes an impact.</label>
                        </div>
                        <div className="donation-one__btn-box">
                          <a href="/about" className="thm-btn">
                            <span className="thm-btn-text">Donate Now</span>
                            <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DonationOne;
